<template>
  <div>
    <b-navbar id="header" type="light" variant="light" sticky>
      <b-navbar-nav>
        <h4 class="mb-0">{{title}}</h4>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-row>
          <b-col>
            <export-sidebar
              sidebar-id="sidebar-organizations-export"
              storage-key="sidebar_organizations_export"
              :columns="exportableFields"
              :data-to-export="dataToExport"
              :data-mapper="mapOrganizationForExport"
              file-name="Organizations.xlsx"
              sheet-name="Organizations"
              :is-busy="isBusy"
              :items-count="totalRows"
            />
          </b-col>
          <b-col cols="auto">
            <b-button id="table-settings" size="sm" variant="warning" class="mr-2" v-b-toggle.sidebar-fields>
              <font-awesome-icon icon="cog"/>
            </b-button>
            <b-tooltip target="table-settings" triggers="hover" variant="warning" noninteractive>
              Колонки
            </b-tooltip>
            <b-btn
              v-if="canEditOrganizations()"
              size="sm"
              variant="success"
              :disabled="isBusy"
              @click="showModal(null, false)"
            >
              <b-spinner v-if="isBusy" small/>
              <font-awesome-icon icon="plus" class="mr-1"/>
              {{ $t("message.organizations.importHand") }}
            </b-btn>
          </b-col>
        </b-row>
      </b-navbar-nav>
    </b-navbar>

    <filters-drawer
      :query.sync="filters.query"
      :is-busy="isBusy"
      @submit="onSearch"
      hide-search-button
    />

    <b-table
      id="organizations"
      ref="organizations"
      class="mb-0 text-small"
      sticky-header
      head-variant="light"
      :tbody-tr-class="tbodyRowClass"
      select-mode="multi"
      striped
      small
      responsive
      show-empty
      :empty-text="$t('message.common.emptyTable')"
      :busy.sync="isBusy"
      :items="items"
      :fields="renderedFields"
      no-provider-filtering
      no-provider-paging
      no-provider-sorting
      no-local-sorting
      @sort-changed="sortChanged"
      @row-clicked="onRowClicked"
      @row-dblclicked="onRowDblClicked"
    >
      <template #table-busy>
        <div class="text-center text-success my-2">
          <b-spinner class="align-middle"/>
          <strong>Загрузка</strong>
        </div>
      </template>

      <template #head(selected)="row">
        <b-form-checkbox
          class="mx-1"
          v-model="allSelected"
          :indeterminate="indeterminate"
          size="md"
          @change="selectPageRows"
        />
      </template>

      <template #cell(selected)="row">
        <template v-if="row.item.selected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Выбрана</span>
        </template>
        <template v-else>
          <span >&nbsp;</span>
          <span class="sr-only">Не выбрана</span>
        </template>
      </template>

      <template #cell(address)="row">
        <div v-if="row.item.address.length<50">{{ row.item.address }}</div>
        <div v-else>{{ row.item.address.substring(0, 50) + ".." }}</div>
      </template>

      <template #cell(action)="row">
        <b-dropdown size="sm" no-caret>
          <template #button-content>
            <font-awesome-icon icon="ellipsis-v"/>
          </template>
          <b-dropdown-item-button variant="success" @click.stop="showModal(row.item.id,true)">
            <font-awesome-icon icon="eye"/>
            Смотреть
          </b-dropdown-item-button>
          <b-dropdown-item-button v-if="canEditOrganizations()" variant="primary" @click="showModal(row.item.id,false)">
            <font-awesome-icon icon="edit"/>
            Редактировать
          </b-dropdown-item-button>
          <b-dropdown-item-button v-if="canEditOrganizations()" variant="danger" @click="onRemove(row)">
            <font-awesome-icon icon="trash"/>
            Удалить
          </b-dropdown-item-button>
        </b-dropdown>
      </template>

      <template #cell(phone)="row">
        <a :href=telUrl(row.item.phone)>{{phoneString(row.item.phone)}}</a>
      </template>
    </b-table>

    <pagination-footer
      :total-rows="totalRows"
      :per-page.sync="perPage"
      @page-click="onPagination"
      @per-page-change="onPerPageChange"
    >
      <template #footer-update>
        <b-row v-if="selected.length > 0" align-h="between" align-v="center">
          <b-col cols="auto" class="mr-auto text-small">
            Выбрано: <b>{{selected.length}}</b>
          </b-col>
        </b-row>
        <hr v-if="selected.length > 0"/>
      </template>
    </pagination-footer>

    <organization ref="organization" v-on:refresh="getItems" @modal-closed="onModalClosed"></organization>

    <dynamic-tables
      storage-key="organizations_columns"
      sidebar-fields="sidebar-fields"
      :fields-model.sync="fields"
      fieldKey="name"
    />

  </div>
</template>

<script>
import organizations from "../../network/organizations";
  import helpers from "../../utilites/helpers";
  import DynamicTables from "../../utilites/commonUi/DynamicTables.vue";
  import FiltersDrawer from "../../utilites/commonUi/FiltersDrawer.vue";
  import ExportSidebar from "../../utilites/commonUi/ExportSidebar.vue";
  import permissions, {PERM} from "../../utilites/permissions";
  import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";
  import pageSearchService from "../../utilites/pageSearchService";
    import Organization from "./Organization";

export default {
  name: "Organizations",
  components: { PaginationFooter, ExportSidebar, FiltersDrawer, DynamicTables, Organization },
  mixins: [
    organizations,
    helpers, permissions, pageSearchService
  ],
  data() {
    return {
      title: 'Организации',
      items: [],
      serviceStartField: {
        key: 'selected',
        label: '',
        class:'organizationsSelect'
      },
      fields: [
        {
          key: 'name',
          label: this.$t('message.customers.table.name'),
          class: 'organizationsName',
          sortable: true,
          visible: true,
          exportable: true,
        },
        {
          key: 'inn',
          label: this.$t('message.customers.table.inn'),
          sortable: true,
          visible: true,
          exportable: true,
        },
        {
          key: 'kpp',
          label: this.$t('message.customers.table.kpp'),
          sortable: true,
          visible: true,
          exportable: true,
        },
        {
          key: 'ogrn',
          label: this.$t('message.customers.table.ogrn'),
          sortable: true,
          visible: true,
          exportable: true,
        },
        {
          key: 'phone',
          label: this.$t('message.customers.table.phone'),
          sortable: true,
          visible: true,
          exportable: true,
        },
        {
          key: 'address',
          label: this.$t('message.customers.table.address'),
          sortable: true,
          visible: true,
          exportable: true,
        },
      ],
      serviceEndField: {
        key: 'action',
        label: this.$t('message.customers.table.actions'),
        class: 'organizationsAction',
      },
      sortBy: 'name',
      sortDesc: true,
      isBusy: false,
      filters: {
        query: '',
      },
      deleteRow: {
        id: null,
        name: '',
      },
      selected: [],
      allSelected: false,
      indeterminate: false,
    }
  },
  async created() {
    const query = this.$route.query;

    if (query && query.query) {
      this.filters.query = query.query;
    }

    if (this.$route.hash) {
      this.currentPage = this.getPage(this.$route.hash);
    }

    await this.onSearch();
  },
  computed: {
    visibleFields() {
      return this.fields.filter(field => field.visible);
    },
    renderedFields() {
      return [
        this.serviceStartField,
        ...this.visibleFields,
        this.serviceEndField
      ];
    },
    dataToExport() {
      return this.selected.length > 0 ? this.selected : this.items;
    },
    exportableFields() {
      return this.fields
        .filter(field => field.exportable)
        .map(field => ({
          key: field.key,
          label: field.label,
          visible: field.visible,
        }));
    },
  },
  watch: {
    '$route.params.id': {
      handler(newId) {
        this.$nextTick(() => {
          if (newId && this.$refs.organization) {
            const isViewonly = this.$route.query.mode === 'view';
            this.$refs.organization.showModal(newId, isViewonly);
          } else if (!newId && this.$refs.organization) {
            this.$refs.organization.hideModal();
          }
        });
      }, immediate: true
    },
    selected(newValue) {
      if (newValue.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newValue.length === this.items.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    },
  },
  methods: {
    async getItems() {
      const data = {
        page: this.currentPage,
        size: this.perPage,
        query: this.filters.query,
        sortBy: [this.sortBy],
        sortDesc: [this.sortDesc],
      };

      this.isBusy = true;
      const result = await this.getOrganizations(data);
      this.isBusy = false;

      if (!result || !result.data) {
        this.items = [];
        this.isBusy = false;
        this.totalRows = 0;
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        return;
      }

      this.items = result.data.items;
      this.totalRows = result.data.total;
      this.updateSelected();
    },
    showModal(organizationId, isViewonly) {
      const canEdit = this.canEditOrganizations();

      if (!organizationId) {
        if (!canEdit) return;

        this.$refs.organization.showModal(null, false);
        return;
      }

      const isView = isViewonly || !canEdit;
      const query = isView ? { mode: 'view' } : {};

      this.$router.push({
        name: 'Organizations',
        params: { id: organizationId },
        query: query
      });
    },
    onRowDblClicked(item) {
      this.showModal(item.id, false);
    },
    onModalClosed() {
      if (this.$route.params.id) {
        this.$router.replace({
          name: 'Organizations',
          params: { id: null },
          hash: this.$route.hash,
        }).catch(()=>{});
      }
    },
    onRemove(row) {
      if (!this.canEditOrganizations()) return;

      if (row.item) {
        this.deleteRow = row.item
      }

      const title = this.$t('message.organizations.modal.removeTitle');
      const message = `${this.$t("message.organizations.modal.removeDesc")} "${this.deleteRow.name}"?`;
      this.showModalDelete(title, message, async () => {
        const result = await this.deleteOrganization(this.deleteRow);

        if (result.error) {
          this.showToast('Ошибка при удалении.', 'Ошибка', 'danger');
        } else {
          this.showToast('Организация удалена.', 'Успех', 'success');
          await this.getItems();
        }
      });
    },
    // Export
    mapOrganizationForExport(item) {
      return {
        name: item.name,
        inn: item.inn,
        kpp: item.kpp,
        ogrn: item.ogrn,
        phone: item.phone,
        address: item.address,
      };
    },
    async selectPageRows(checked) {
      this.selected = checked ? [...this.items] : [];
      this.updateSelected();
    },
    onRowClicked(item) {
      // Ищем уже выбранные
      const existItem = this.selected.findIndex(e => e.id === item.id);

      if (existItem !== -1) {
        this.selected.splice(existItem, 1);
      } else {
        this.selected.push(item);
      }
      this.updateSelected();
    },
    updateSelected() {
      this.items.forEach((item) => {
        const isSelected = this.selected.some(e => e.id === item.id);
        this.$set(item, 'selected', isSelected);
      });
    },
    tbodyRowClass(item) {
      return item && item.selected ? ["b-table-row-selected", "table-primary", "pointer-cell"] : ["pointer-cell"];
    },
    // Permissions
    canEditOrganizations() {
      return this.hasPermission([PERM.ORGANIZATION_EDIT]);
    }
  },
}
</script>

<style>
@media screen
and (min-width: 768px) {
  a[href*="tel:"] {
    pointer-events: none;
    cursor:default;
    text-decoration: none;
  }
}

.organizationsName {
  padding-left: 10px !important;
  min-width: 200px;
  max-width: 300px;
}

.organizationsAction {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}

.organizationsSelect {
  min-width: 50px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Organizations/Organizations.vue